// extracted by mini-css-extract-plugin
export default {"container":"ResumeInput_container__guJ9t","label":"ResumeInput_label__LEF4T","attatchWrap":"ResumeInput_attatchWrap__6ILy5"};